import axios from 'axios'

export async function toggleLoadPriority({loadId, priorityLoad}) {
    const result = await axios({
          method: "patch",
          url: `/api/loads/${loadId}`,
          data: {
              priority_load: priorityLoad
          }
      })
  
      return result
  }